/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantPromptResponseDto
 */
export interface AssistantPromptResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssistantPromptResponseDto
     */
    output: string;
}

/**
 * Check if a given object implements the AssistantPromptResponseDto interface.
 */
export function instanceOfAssistantPromptResponseDto(value: object): value is AssistantPromptResponseDto {
    if (!('output' in value) || value['output'] === undefined) return false;
    return true;
}

export function AssistantPromptResponseDtoFromJSON(json: any): AssistantPromptResponseDto {
    return AssistantPromptResponseDtoFromJSONTyped(json, false);
}

export function AssistantPromptResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantPromptResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'output': json['output'],
    };
}

export function AssistantPromptResponseDtoToJSON(json: any): AssistantPromptResponseDto {
    return AssistantPromptResponseDtoToJSONTyped(json, false);
}

export function AssistantPromptResponseDtoToJSONTyped(value?: AssistantPromptResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'output': value['output'],
    };
}

